export type TriggerType = 'area_entry' | 'ui_click';

export type TriggerInterruption =
  | 'finish_step'
  | 'hard_cut'
  | 'non_interruptible';

export enum PlaybackPolicy {
  ALWAYS = 'always',
  ONCE_SESSION = 'once_session',
  ONCE_USER = 'once_user',
  FIRST_TIME = 'first_time',
}

export interface IAssistantScript {
  scriptId: string;
  scriptData: string;
  scriptTrigger: string | string[];
  triggerType: TriggerType;
  interruptMode: TriggerInterruption;
  canUserSkip: boolean;
  startScriptButtonTitle?: string;
  uiClickButtonLabel?: string;
  createdAt: string;
  updatedAt: string;
  createdBy: string;
  engine?: string;
  voiceId?: string;
  mapName: string;
  playbackPolicy?: PlaybackPolicy;
  skipFirstSession?: boolean;
}
